import React from 'react';
import { Icon } from '@ss/mtd-react';
import { useRootStore } from '@src/model';

import './index.scss';

// 仅社招
const SelfDescriptionView = (props) => {
  const { data, setMode } = props;
  const { socialResumeFormRefStore } = useRootStore();

  const storeRef = socialResumeFormRefStore;

  const handleEdit = () => {
    setMode('edit');
    storeRef.setCurrentScrollRef('self_description_edit');
  };

  return data ? (
    <div className="self_description_view model_view">
      <div className="model_title">
        <div>自我描述</div>
        <div className="edit_icon" onClick={() => handleEdit()}>
          <Icon type="edit-o" style={{ color: '#A9AFB8', fontSize: 22 }} />
        </div>
      </div>
      <div className="model_list">
        <div className="model_bottom">
          <div className="label">
            <span>{data || '-'}</span>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default SelfDescriptionView;
